import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ISelectItem } from '@shared/models/interfaces/select-item.interface';
import { FormField } from '@shared/components/form/models/beans/form-field.abstract';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { Subscription } from 'rxjs';
import { getControl } from '@shared/helpers/form.helper';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'selectfield[form]',
    templateUrl: './selectfield.component.html',
    styleUrls: ['./selectfield.component.scss'],
})
export class SelectfieldComponent extends FormField implements OnInit, OnDestroy {
    @Input() selectedString: string;
    @Input() items: ISelectItem[];
    @Input() enableChangeListener = false;
    @Output() onchange = new EventEmitter();
    override placeholder = 'Seleziona';

    private _subs = new Subscription();
    constructor() {
        super();
    }

    ngOnInit(): void {
        if (this.form && this.enableChangeListener && (this.fieldControl || !isNilOrEmpty(this.fieldName))) {
            const targetControl = this.fieldControl || getControl(this.form, this.fieldName);
            this._subs.add(
                targetControl?.valueChanges.pipe(filter((value) => !!value)).subscribe((value) => {
                    this.onchange.emit(value);
                })
            );
        }
    }

    ngOnDestroy(): void {
        this._subs.unsubscribe();
    }
}
